/**
 * @usage v-if="$checkPriviledged('edit_permits')"
 * @usage this.$checkPriviledged('edit_permits')
 * @type Boolean
 */

import { store } from '../../store'

const PRIVILEGED_MAILS = {
  'parkingbadge.com': {
    sales: ['CAN_EDIT_MANAGER_PASSWORD', 'CAN_DOWNLOAD_RESERVED_PERMITS', 'CAN_EDIT_RESERVED_PERMITS']
  }
}

export default function priviledgedMailAccess (rule = null) {
  const { role_slug: userRole, email: userMail } = store.getters['authStore/getUser']

  if (!rule) return false

  const _mail = PRIVILEGED_MAILS[userMail.split('@')[1]]

  if (!_mail) return false

  const _role = _mail[userRole]

  if (!_role) return false

  return _role.includes(rule)
}



// WEBPACK FOOTER //
// ./src/roles/priviledged/index.js